// tslint:disable: variable-name
import { BaseResourceModel } from '../../models/base-resource.model';
import { Orgao } from '../comum/orgao.model';
import { PacienteProcesso } from './paciente-processo.model';

export class Paciente extends BaseResourceModel {
  constructor(
    public id?: number,
    public codigo?: number,
    public nome?: string,
    public cpf?: string,
    public telefone?: string,
    public orgao?: Orgao,
    public paciente_processo?: PacienteProcesso[]
  ) {
    super();
  }
  static converteJson(json: any): Paciente {
    return Object.assign(new Paciente(), json);
  }
}
